import * as yup from "yup";
import { clientDetailsFormExcludingPricingPlan } from "../sharedFormSchema";

export const mainUserForm = yup.object({
  email: yup
    .string()
    .email("The email is not in the right format")
    .required("Email is required"),
  "main-user-first-name": yup
    .string()
    .required("Owner first name is required")
    .min(2, "Must be two characters or more")
    .trim(),
  "main-user-last-name": yup
    .string()
    .required("Owner last name is required")
    .min(2, "Must be two characters or more")
    .trim(),
});

export const addClientForm =
  clientDetailsFormExcludingPricingPlan.concat(mainUserForm);
